var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 135.5,
    cy: 134.5,
    r: 124.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.3291,
    y: 90.3403,
    width: 95.51,
    height: 104.052,
    rx: 7,
    transform: "rotate(-27.263 2.3291 90.3403)",
    fill: "url(#paint0_linear_714_29559)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2153,
    y: 93.3091,
    width: 73.7679,
    height: 20.9656,
    rx: 7,
    transform: "rotate(-27.263 15.2153 93.3091)",
    fill: "#024E82"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3755,
    y: 118.848,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 28.3755 118.848)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.7783,
    y: 131.273,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 34.7783 131.273)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.1812,
    y: 143.697,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 41.1812 143.697)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5835,
    y: 156.122,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 47.5835 156.122)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6318,
    y: 109.956,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 45.6318 109.956)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0347,
    y: 122.38,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 52.0347 122.38)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 58.4365,
    y: 134.805,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 58.4365 134.805)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8394,
    y: 147.229,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 64.8394 147.229)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 62.1973,
    y: 101.419,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 62.1973 101.419)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 68.6006,
    y: 113.843,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 68.6006 113.843)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 75.0029,
    y: 126.268,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 75.0029 126.268)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4053,
    y: 138.692,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 81.4053 138.692)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 79.4536,
    y: 92.5269,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 79.4536 92.5269)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 85.8564,
    y: 104.951,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 85.8564 104.951)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2593,
    y: 117.375,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 92.2593 117.375)",
    fill: "#9E9E9E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 98.6616,
    y: 129.8,
    width: 16.3066,
    height: 10.0946,
    rx: 5.04728,
    transform: "rotate(-27.263 98.6616 129.8)",
    fill: "#9E9E9E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.247 34.4386C200.13 73.4391 169.332 124.217 169.332 124.217C169.332 124.217 203.695 101.362 208.513 68.3279L199.027 66.5831C199.027 66.5831 204.455 64.226 209.048 62.3307C209.322 53.5848 207.414 44.2137 202.247 34.4386Z",
    fill: "url(#paint1_linear_714_29559)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.976 73.1099L167.456 70.5646L162.491 68.9665C165.075 62.8042 168.776 57.5771 172.887 53.1982C176.537 55.0153 180.731 56.9841 180.731 56.9841L177.034 49.1629C188.763 38.7164 201.804 34.3652 201.804 34.3652C199.606 73.352 169.23 124.2 169.23 124.2C157.775 102.959 156.873 86.156 160.976 73.1099Z",
    fill: "url(#paint2_linear_714_29559)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210.734 74.4183C204.318 75.9934 198.285 78.8602 193 82.8451C193.146 85.6385 193.252 88.9905 193.252 88.9905L189.723 85.5325C172.169 101.165 168.312 125.622 168.312 125.622C183.592 122.073 193.444 115.621 199.779 108.466C199.007 106.806 197.825 104.362 197.825 104.362L201.732 106.1C204.314 102.729 206.391 98.9958 207.897 95.0205C205.857 94.1321 203.582 93.0607 203.582 93.0607L209.065 91.5222C211.82 82.0194 210.734 74.4183 210.734 74.4183Z",
    fill: "#B7D972"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.211 90.2005L135.112 167.799L174.716 199.802L237.815 122.203L198.211 90.2005Z",
    fill: "url(#paint3_linear_714_29559)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.02 123.359L175.12 196.021L139.392 167.054L198.291 94.3919L234.02 123.359ZM174.681 191.771L229.775 123.805L198.75 98.6452L143.656 166.612L174.681 191.771Z",
    fill: "#CFE2A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.426 134.424L152.965 153.234L162.614 203.113L261.075 184.303L251.426 134.424Z",
    fill: "url(#paint4_linear_714_29559)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.279 182.381L165.143 199.873L156.373 154.856L248.515 137.365L257.279 182.381ZM167.538 196.349L253.718 179.994L246.114 140.888L159.933 157.243L167.538 196.349Z",
    fill: "#CFE2A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.192 161.895C243.091 161.367 242.835 160.881 242.457 160.499C242.08 160.116 241.597 159.854 241.071 159.746C240.544 159.638 239.997 159.688 239.499 159.891C239.002 160.093 238.575 160.439 238.273 160.884C237.972 161.329 237.809 161.853 237.806 162.391C237.802 162.928 237.958 163.454 238.254 163.903C238.55 164.352 238.972 164.703 239.467 164.912C239.962 165.121 240.509 165.178 241.036 165.077C241.387 165.01 241.721 164.874 242.019 164.677C242.317 164.481 242.573 164.228 242.773 163.932C242.974 163.637 243.114 163.305 243.186 162.955C243.257 162.606 243.26 162.245 243.192 161.895Z",
    fill: "#CFE2A3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_714_29559)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 85.8037,
    fill: "url(#paint5_linear_714_29559)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_714_29559)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 107.512,
    transform: "rotate(17.7627 135.5 135.5)",
    stroke: "url(#paint6_linear_714_29559)",
    strokeWidth: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_714_29559)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 92.764,
    transform: "rotate(-158.679 135.5 135.5)",
    stroke: "url(#paint7_linear_714_29559)",
    strokeWidth: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_714_29559)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 92.6374,
    transform: "rotate(77.8554 135.5 135.5)",
    stroke: "url(#paint8_linear_714_29559)",
    strokeWidth: 0.5
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.925 135.8C180.943 144.864 178.271 153.73 173.248 161.275C168.225 168.821 161.077 174.707 152.708 178.188C144.339 181.67 135.125 182.59 126.233 180.834C117.34 179.077 109.169 174.722 102.752 168.319C96.3357 161.917 91.9626 153.755 90.1862 144.867C88.4099 135.978 89.3101 126.762 92.7731 118.386C96.2361 110.009 102.106 102.848 109.64 97.8081C117.175 92.7685 126.035 90.0772 135.099 90.0747C147.241 90.0914 158.882 94.9197 167.471 103.502C176.061 112.084 180.899 123.721 180.925 135.863V135.8ZM149.978 127.532H152.898C155.095 127.431 157.296 127.481 159.485 127.684C160.907 127.943 162.171 128.751 163.004 129.934C163.836 131.116 164.17 132.578 163.935 134.005C163.726 135.406 163.003 136.679 161.907 137.577C160.811 138.474 159.42 138.931 158.006 138.859C152.393 138.859 146.78 138.859 141.167 138.922H140.244C140.244 142.133 139.612 143.309 136.452 143.587C135.718 143.701 134.972 143.739 134.252 143.878C132.773 144.131 132.431 145.142 132.431 146.634H133.62C141.534 146.634 149.46 146.634 157.374 146.634C158.743 146.671 160.112 146.561 161.457 146.305C164.622 145.516 167.393 143.605 169.257 140.927C171.12 138.249 171.948 134.986 171.589 131.744C171.229 128.502 169.705 125.5 167.3 123.296C164.896 121.091 161.773 119.834 158.511 119.758H143.973C143.723 119.721 143.468 119.744 143.228 119.824C142.988 119.904 142.77 120.039 142.592 120.219C142.414 120.398 142.28 120.617 142.201 120.857C142.123 121.098 142.102 121.353 142.14 121.603V135.585C142.14 135.825 142.14 136.053 142.14 136.293H149.928L149.978 127.532ZM128.879 136.293V121.54C128.879 120.187 128.336 119.631 126.945 119.631H112.647C111.906 119.644 111.167 119.707 110.435 119.821C107.125 120.378 104.141 122.151 102.069 124.792C99.9974 127.433 98.9857 130.752 99.2324 134.1C99.4791 137.448 100.966 140.583 103.403 142.892C105.84 145.201 109.051 146.517 112.407 146.583H130.472C130.472 143.069 131.306 141.881 134.593 141.59C134.985 141.527 135.39 141.514 135.782 141.476C137.615 141.299 138.31 140.515 138.31 138.872H137.046C128.791 138.872 120.523 138.872 112.268 138.72C110.875 138.619 109.57 138.005 108.604 136.997C107.639 135.988 107.081 134.658 107.041 133.262C107 131.866 107.478 130.505 108.383 129.442C109.288 128.379 110.555 127.689 111.939 127.507C114.784 127.355 117.653 127.431 120.51 127.418C120.697 127.452 120.88 127.507 121.054 127.583V136.217L128.879 136.293ZM124.29 117.267C125.869 117.257 127.41 116.779 128.718 115.894C130.025 115.009 131.042 113.757 131.638 112.294C132.234 110.832 132.384 109.226 132.068 107.679C131.751 106.132 130.984 104.713 129.862 103.601C128.74 102.49 127.314 101.736 125.764 101.435C124.214 101.134 122.61 101.298 121.153 101.908C119.697 102.518 118.453 103.546 117.581 104.862C116.708 106.179 116.245 107.724 116.25 109.303C116.277 111.414 117.137 113.429 118.643 114.909C120.149 116.389 122.179 117.214 124.29 117.204V117.267ZM146.578 101.427C144.995 101.44 143.451 101.922 142.143 102.813C140.835 103.705 139.821 104.964 139.23 106.433C138.639 107.901 138.498 109.512 138.823 111.061C139.149 112.61 139.928 114.027 141.06 115.133C142.193 116.239 143.628 116.983 145.184 117.272C146.74 117.561 148.347 117.381 149.801 116.755C151.255 116.129 152.49 115.085 153.35 113.756C154.21 112.427 154.655 110.873 154.63 109.29C154.61 107.172 153.752 105.149 152.242 103.663C150.733 102.177 148.696 101.35 146.578 101.364V101.427ZM128.879 149.011H121.092V170.969C125.099 170.969 129.043 170.969 132.988 170.906C133.307 170.829 133.601 170.673 133.844 170.452C134.087 170.231 134.271 169.952 134.378 169.642C134.602 168.633 134.42 167.577 133.871 166.702C133.322 165.827 132.451 165.202 131.445 164.964C130.61 164.823 129.764 164.747 128.917 164.737L128.879 149.011ZM149.966 170.957V148.96H142.065V164.788H140.649C139.716 164.765 138.805 165.066 138.069 165.64C137.334 166.214 136.82 167.025 136.616 167.935C136.224 169.528 136.742 170.856 137.88 170.868C141.925 170.982 145.92 170.893 149.966 170.893V170.957Z",
    fill: "#06477D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_714_29559",
    x: 41.6963,
    y: 41.6963,
    width: 187.607,
    height: 187.607,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_714_29559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_714_29559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_714_29559",
    x: 19.7095,
    y: 19.7095,
    width: 231.581,
    height: 231.581,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_714_29559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_714_29559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_714_29559",
    x: 34.4609,
    y: 34.4609,
    width: 202.078,
    height: 202.078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_714_29559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_714_29559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_714_29559",
    x: 34.5933,
    y: 34.5933,
    width: 201.813,
    height: 201.813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_714_29559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_714_29559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_714_29559",
    x1: 26.4007,
    y1: -45.9337,
    x2: -13.2371,
    y2: 174.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_714_29559",
    x1: 177.028,
    y1: 77.8719,
    x2: 206.138,
    y2: 82.7057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#287F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_714_29559",
    x1: 201.105,
    y1: 102.638,
    x2: 134.401,
    y2: 5.17361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#287F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_714_29559",
    x1: 186.96,
    y1: 96.7835,
    x2: 184.845,
    y2: 277.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#287F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_714_29559",
    x1: 207.808,
    y1: 97.0375,
    x2: 205.694,
    y2: 277.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#287F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_714_29559",
    x1: 203.385,
    y1: 55.2098,
    x2: 69.6827,
    y2: 235.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_714_29559",
    x1: 108.194,
    y1: 201.815,
    x2: 110.632,
    y2: 190.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_714_29559",
    x1: 111.931,
    y1: 192.739,
    x2: 114.035,
    y2: 183.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_714_29559",
    x1: 111.963,
    y1: 192.662,
    x2: 114.064,
    y2: 182.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.e7c551a9a267cef15d1010ba6277e2d1.svg";
export { ForwardRef as ReactComponent };